<!-- Copyright (c) 2019-2024 Cigent Technology Inc. All Rights Reserved. -->

@if (securityRequestsEnabled && user$ | async; as user) {
    <div class="key_id">
        @if (user.org_type.value == customerType) {
            @if (!currentRequest?.found || currentRequest.status == Status.CANCELLED) {
                <span class="mdi mdi-information" matTooltip="{{'endpoints.key_request.request_tooltip' | translate}}"></span>
                <button mat-raised-button (click)="requestBitLockerKeyAccess()">
                    <span class="mdi mdi-key"></span>
                    {{'bitlocker-key-request.request-recovery-key' | translate}}
                </button>
            } @else if (currentRequest?.status == Status.APPROVED || currentRequest?.status == Status.ACCEPTED) {
                <span class="mdi mdi-information" matTooltip="{{'endpoints.key_request.show_key'  | translate}}"></span>
                <button mat-raised-button color="primary" (click)="showBitLockerKey(currentRequest.id)">
                    <span class="mdi mdi-key-outline"></span>
                    {{'bitlocker-key-request.view-recovery-key' | translate}}
                </button>
            } @else if (currentRequest?.status == Status.DENIED) {
                <span class="mdi mdi-information" matTooltip="{{'endpoints.key_request.request_denied'  | translate}}"></span>
                <button mat-raised-button color="warn" (click)="viewKeyRequestStatus(currentRequest.id)">
                    <span class="mdi mdi-key-remove"></span>
                    {{'bitlocker-key-request.view-denied-request' | translate}}
                </button>
            } @else if (currentRequest?.status == Status.PENDING) {
                <span class="mdi mdi-information" matTooltip="{{'endpoints.key_request.request_pending'  | translate}}"></span>
                <button mat-raised-button color="accent" (click)="viewKeyRequestStatus(currentRequest.id)">
                    <span class="mdi mdi-key-star"></span>
                    {{'bitlocker-key-request.view-request-status' | translate}}
                </button>
            }
        } @else {
            <span class="mdi mdi-key config-icon" matTooltip="{{'endpoints.key_request.request_tooltip' | translate}}"></span>
        }
    </div>
}
